import React from "react";
import { hot } from "react-hot-loader/root";
import { Route, Switch } from "react-router-dom";
import { getPath } from "common/routing";
import PublicUserContextProvider from "../Authentication/PublicUserContext";
import GuestAuthContextProvider from "../Authorization/GuestAuthContext";
import DetailView from "../DocumentUploads/DetailView";
import Map from "../Maps";
import CreateSubmissionContainer from "../Submissions/CreateSubmission";
import EditSubmission from "../Submissions/EditSubmission";
import SubmissionSummary from "../Submissions/SubmissionSummary";
import ViewSubmission from "../Submissions/ViewSubmission";
import AccessDeniedPage, { ACCESS_DENIED_RESOURCE } from "./AccessDeniedPage";
import CertificatesPage from "./ElevationCertificates";
import UploadElevationCertificatesPage from "./ElevationCertificates/UploadElevationCertificates";
import GetHelpPage from "./GetHelp";
import GuestPropertySearch from "./index";
import NoPropertyPage from "./NoPropertyPage";
import ResidentPropertyPage from "./Property";
import PropertyRedirect from "./PropertyRedirect";
import SavedView from "./SavedView";
import { ListWorkflows } from "./Workflows/ListWorkflows";
import { Workflow } from "./Workflows/Workflow";
import { WorkflowDefinition } from "./Workflows/WorkflowDefinition";

// we have to export this in isolation so that hot reloading works
export const MainRoutes = hot(() => (
  <Switch>
    <PublicUserContextProvider>
      <GuestAuthContextProvider>
        <Switch>
          <Route
            path={getPath("guestUploadElevationCertificates")}
            component={UploadElevationCertificatesPage}
          />
          <Route
            path={getPath("guestElevationCertificates")}
            component={CertificatesPage}
          />
          <Route
            path={getPath("guestDocumentUploadDetail")}
            component={DetailView}
          />
          <Route
            // if we have gotten to this route, the middleware has not found a file
            // therefore we should always return an access denied page
            path={getPath("guestDocumentUploadFile")}
            render={() => (
              <AccessDeniedPage resource={ACCESS_DENIED_RESOURCE.FILE} />
            )}
          />
          <Route path={getPath("getHelp")} component={GetHelpPage} />
          <Route path={getPath("noProperty")} component={NoPropertyPage} />
          <Route
            path={getPath("residentProperty")}
            component={ResidentPropertyPage}
          />
          <Route
            path={getPath("residentPropertyRedirect")}
            component={PropertyRedirect}
          />
          <Route
            exact
            path={getPath("guestHome")}
            component={GuestPropertySearch}
          />
          <Route path={getPath("explore")} component={Map} />
          <Route
            path={getPath("createSubmission")}
            component={CreateSubmissionContainer}
          />
          <Route
            path={getPath("submissionSummary")}
            component={SubmissionSummary}
          />
          <Route path={getPath("editSubmission")} component={EditSubmission} />
          <Route path={getPath("viewSubmission")} component={ViewSubmission} />
          <Route path={getPath("residentSavedView")} component={SavedView} />
          <Route
            path={getPath("workflowDefinition")}
            component={WorkflowDefinition}
          />
          <Route path={getPath("listWorkflows")} component={ListWorkflows} />
          <Route path={getPath("workflow")} component={Workflow} />
        </Switch>
      </GuestAuthContextProvider>
    </PublicUserContextProvider>
  </Switch>
));
